'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Angle = function Angle(options) {
  var ANGLE_MAP = {
    down: '\'\\f107\'',
    up: '\'\\f106\'',
    right: '\'\\f105\'',
    left: '\'\\f104\''
  };
  var defaults = {
    angle: 'down',
    position: 'before',
    color: 'inherit',
    size: 'inherit'
  };
  var settings = _extends({}, defaults, options);
  var marginDirection = settings.position === 'before' ? 'right' : 'left';

  return '\n    &::' + settings.position + ' {\n      color: ' + settings.color + ';\n      content: ' + ANGLE_MAP[settings.angle] + ';\n      font-family: \'Font Awesome 5 Free\';\n      font-size: ' + settings.size + ';\n      font-weight: 900;\n      margin-' + marginDirection + ': 3px;\n    }\n  ';
};

exports.default = Angle;